import React from "react";
import PropTypes from "prop-types";
import {Edit as EditIcon, Comment as FeedbackIcon} from "@material-ui/icons";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import MenuHeader from "../../components/MenuHeader";
import MenuBackButton from "../../components/MenuBackButton";
import LinkMenuItem from "../../components/LinkMenuItem";

import "./style.scss";

export default class AccountMenu extends React.Component {
  render() {
    const {match, onClose} = this.props;
    const baseAccountPage = /^\/account\/?$/.test(match.url);

    return (
      <React.Fragment>
        <MenuBackButton to={"/map"} />
        <List>
          <MenuHeader>Account</MenuHeader>
          <LinkMenuItem
            to={`/account`}
            onClick={onClose}
            selected={baseAccountPage}
            primary={<p className="menuItemText">My Profile</p>}
            iconRight={<EditIcon />}
          />
          <Divider />
          {this.renderAccountSettings()}
          {this.renderAccountUsers()}
          <LinkMenuItem
            to={`/account/feedback`}
            onClick={onClose}
            selected={match.url.startsWith("/account/feedback")}
            primary={<p className="menuItemText">Give Feedback</p>}
            iconRight={<FeedbackIcon />}
          />
        </List>
      </React.Fragment>
    );
  }

  renderAccountSettings() {
    if (this.canEditAccount()) {
      const {match, onClose} = this.props;
      return (
        <React.Fragment>
          <LinkMenuItem
            to={`/account/settings`}
            onClick={onClose}
            selected={match.url.startsWith("/account/settings")}
            primary={<p className="menuItemText">Organization & Billing</p>}
            iconRight={<EditIcon />}
          />
          <Divider />
        </React.Fragment>
      );
    }
  }

  renderAccountUsers() {
    if (this.canEditUsers()) {
      const {match, onClose} = this.props;
      return (
        <React.Fragment>
          <LinkMenuItem
            to={`/account/users`}
            onClick={onClose}
            selected={match.url.startsWith("/account/users")}
            primary={<p className="menuItemText">Users</p>}
            iconRight={<EditIcon />}
          />
          <Divider />
          <LinkMenuItem
            to={`/account/groups`}
            onClick={onClose}
            selected={match.url.startsWith("/account/groups")}
            primary={<p className="menuItemText">Groups</p>}
            iconRight={<EditIcon />}
          />
          <Divider />
        </React.Fragment>
      );
    }
  }

  canEditUsers() {
    return this.props.currentUser.permissions.edit.users;
  }

  canEditAccount() {
    return this.props.currentUser.permissions.edit.account;
  }
}

AccountMenu.propTypes = {
  currentUser: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/components/Sidebar/Menus/AccountMenu/index.jsx